import classNames from 'classnames';
import { fromUnixTime } from 'date-fns';

import { useTimeZonedFunctions } from '/src/hooks';

export function DateRange({ className, dateRange }) {
  const {
    getConvertedDateRange,
    isSameDay,
    isSameMonth,
    isSameYear,
    formatDay,
    formatRangeSameMonth,
    formatRangeSameYear,
    formatRangeDifferentYear,
  } = useTimeZonedFunctions();
  const { startDate, endDate } = getConvertedDateRange(dateRange);

  if (!Number.isFinite(startDate) || !Number.isFinite(endDate)) {
    return '';
  }

  const parsedStart = fromUnixTime(startDate);
  const parsedEnd = fromUnixTime(endDate);

  let printedRange;
  if (isSameDay(parsedStart, parsedEnd)) {
    printedRange = formatDay(parsedEnd);
  } else if (isSameMonth(parsedStart, parsedEnd)) {
    printedRange = formatRangeSameMonth(parsedStart, parsedEnd);
  } else if (isSameYear(parsedStart, parsedEnd)) {
    printedRange = formatRangeSameYear(parsedStart, parsedEnd);
  } else {
    printedRange = formatRangeDifferentYear(parsedStart, parsedEnd);
  }

  return <div className={classNames(className)}>{printedRange}</div>;
}
